// extracted by mini-css-extract-plugin
export default {"wrap":"index-module_wrap_15qUx","tabs":"index-module_tabs_-JZZP","current":"index-module_current_Vz0vz","content":"index-module_content_e920V"};